<div class="page-header">
  <a [routerLink]="['/mobiel/activiteiten/overzicht']">
    <i class="fa-regular fa-chevron-left"></i>
  </a>
  <h3 class="page-header__title">
    {{ date | date : "longDate" }}
  </h3>
</div>

<app-activity-schedule-detail-form [activitySchedule]="activitySchedule$ | async" (save)="onSave($event)"></app-activity-schedule-detail-form>